export const FETCH_POST_COMMENT_LIKED_USERS_REQUEST = 'FETCH_POST_COMMENT_LIKED_USERS_REQUEST';
export const FETCH_POST_COMMENT_LIKED_USERS_SUCCESS = 'FETCH_POST_COMMENT_LIKED_USERS_SUCCESS';
export const FETCH_POST_COMMENT_LIKED_USERS_FAILURE = 'FETCH_POST_COMMENT_LIKED_USERS_FAILURE';
export const FETCH_POST_COMMENT_LIKED_USERS_RESET = 'FETCH_POST_COMMENT_LIKED_USERS_RESET';